export default __webpack_public_path__ + "img/56f565ce088dbbc5d177bd8cf07bcc09.svg";